<div class="main-wrapper">
    <div class="app flex-row align-items-center error-component">
        <div class="container">
            <div class="row justify-content-center vertical-center">
                <div class="col-md-6">
                    <div class="clearfix text-center">
                        <img src="assets/img/errors/401-error.svg" style="max-height: 300px;">
                        <h4 class="pt-4">Oops! Access Denied.</h4>
                        <p class="text-muted mb-4">The page you are looking for has not access for you.</p>
                        <a routerLink="/" class="bd_btn green_btn">Home</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>